<template>
  <app-dialer-common-page
    class="app-dialer-keypad-page"
    :title="$t('hitl.modules.dialer.keypad-popup-title')"
    :is-disabled="isDisabled"
    @go-back="$emit('go-back', $event)"
  >
    <div class="keypad-page-content">
      <app-dialer-keypad
        size="mobile"
        :dial="dial"
        :is-disabled="isDisabled"
        @key-click="onKeyClick"
      />

      <div class="actions">
        <div
          class="icon-button is-mobile"
          @click="onBackspaceClick"
        >
          <or-icon icon="backspace" />
        </div>
      </div>
    </div>
  </app-dialer-common-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';
import { AppDialerKeypad, AppDialerCommonPage } from '../common';

export default defineComponent({
  name: 'AppDialerKeypadPage',
  components: {
    AppDialerCommonPage,
    AppDialerKeypad,
    OrIcon,
  },
  props: {
    isDisabled: Boolean,
  },
  emits: ['key-click', 'go-back'],
  data() {
    return {
      dial: '',
    };
  },
  methods: {
    onKeyClick(key: string) {
      this.dial += key;
      this.$emit('key-click', key);
    },

    onBackspaceClick() {
      if (!this.isDisabled && this.dial.length) {
        this.dial = this.dial.slice(0, -1);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../../styles';

.app-dialer-keypad-page {
  .keypad-page-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 14rem;
    margin: 1.5rem auto 0;
  }

  .actions {
    display: flex;
    width: 100%;
    margin-top: 1.5rem;

    .icon-button {
      @include app-dialer-icon-button;

      height: 2rem;
      width: 2rem;
      margin-left: auto;
      margin-right: 0.75rem;

      ::v-deep .or-icon-v3 {
        font-size: 1.75rem;
      }
    }
  }
}
</style>
